import { defineAction, number, object } from '~/prix'
import ruralEnvironmentalRegistryFetchAction from './ruralEnvironmentalRegistryFetch.action.json' assert { type: 'json' }

const ruralEnvironmentalRegistryFetchDefinition = defineAction({
  ...ruralEnvironmentalRegistryFetchAction,

  input: object({
    municipalityId: number(),
  }),
  output: object<any>({}),
})

export default ruralEnvironmentalRegistryFetchDefinition
